import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading, checkAuth, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If user data was passed from AuthCallback, skip auth check
    if (location.state?.user) {
      return;
    }

    const verifyAuth = async () => {
      if (!loading) {
        if (!isAuthenticated) {
          navigate('/giris', { state: { from: location.pathname } });
        } else if (requiredRole && user?.role !== requiredRole && user?.role !== 'admin') {
          // Admins can access all routes
          navigate('/hesabim');
        }
      }
    };

    verifyAuth();
  }, [loading, isAuthenticated, user, requiredRole, navigate, location]);

  if (loading) {
    return null; // No loading screen, just wait
  }

  if (!isAuthenticated) {
    return null;
  }

  if (requiredRole && user?.role !== requiredRole && user?.role !== 'admin') {
    return null;
  }

  return children;
};

export default ProtectedRoute;
